"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minLength = function (minLength) {
    return function (value) {
        return typeof value === 'string' && value.length >= minLength;
    };
};
exports.maxLength = function (maxLength) {
    return function (value) {
        return typeof value === 'string' && value.length <= maxLength;
    };
};
exports.minLengthOrEmpty = function (minLength) {
    return function (value) {
        return (typeof value === 'string' && value.length >= minLength) || !value;
    };
};
